import * as React from "react";
import type { SVGProps } from "react";
const SvgAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#E91E63"
      fillRule="evenodd"
      d="M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 8.333V5M8 10.667a.167.167 0 1 0 .002.333.167.167 0 0 0-.003-.333"
    />
  </svg>
);
export default SvgAlert;
